const SET_FAQS_ITEMS = 'SET_FAQS_ITEMS';
const SET_FAQS_CATEGORIES = 'SET_FAQS_CATEGORIES';
const SET_FAQS_BY_CATEGORY = 'SET_FAQS_BY_CATEGORY';

export default {
  SET_FAQS_ITEMS,
  SET_FAQS_CATEGORIES,
  SET_FAQS_BY_CATEGORY,
};
